export const fiscalItems = [
  { category: "Fiscal", key: "empresasDocumentosFiscais", name: "Empresas e documentos ficais" },

];
